'use client';

import { useRef } from "react";
const idProp = "chalkUseIdCounter";
const windowStub = {};
function claimNextId() {
  const isSsr = typeof window !== "object" || window === null;
  const w = isSsr ? windowStub : window;
  w.Thinkific = w.Thinkific || {};
  let nextId = (w.Thinkific[idProp] ?? 0) + 1;
  if (nextId >= Number.MAX_SAFE_INTEGER) nextId = 0;
  w.Thinkific[idProp] = nextId;
  return nextId;
}
function useId() {
  const idCounterRef = useRef(null);
  const isFirstRender = idCounterRef.current === null;
  if (isFirstRender) {
    idCounterRef.current = claimNextId();
  }
  return `chalk-useid-${idCounterRef.current}`;
}
export {
  claimNextId,
  useId
};
